import '../scss/main.scss';
import '@fortawesome/fontawesome-free/css/all.min.css';
import '@fontsource/manrope/cyrillic-400.css';
import '@fontsource/manrope/cyrillic-700.css';
import '@fontsource/manrope/cyrillic-800.css';
import '@fontsource/manrope/latin-400.css';
import '@fontsource/manrope/latin-700.css';
import '@fontsource/manrope/latin-800.css';
import '@fontsource/roboto-condensed/cyrillic-800.css';
import '@fontsource/roboto-condensed/latin-800.css';
import Swiper from 'swiper';
import { Navigation, A11y } from 'swiper/modules';
import 'swiper/css';

const menuToggle = document.querySelector('[data-menu-toggle]');
const navigation = document.querySelector('[data-navigation]');
const siteHeader = document.querySelector('[data-site-header]');

if (siteHeader) {
  const updateHeaderState = () => {
    siteHeader.classList.toggle('is-scrolled', window.scrollY > 18);
  };

  updateHeaderState();
  window.addEventListener('scroll', updateHeaderState, { passive: true });
}

const scrollTopButtons = document.querySelectorAll('[data-scroll-top]');

if (scrollTopButtons.length) {
  const updateScrollTopVisibility = () => {
    scrollTopButtons.forEach((button) => {
      button.classList.toggle('is-visible', window.scrollY > 500);
    });
  };

  updateScrollTopVisibility();
  window.addEventListener('scroll', updateScrollTopVisibility, { passive: true });

  scrollTopButtons.forEach((button) => {
    button.addEventListener('click', () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  });
}

if (menuToggle && navigation) {
  const closeMenu = () => {
    menuToggle.setAttribute('aria-expanded', 'false');
    navigation.classList.remove('is-open');
    document.body.classList.remove('menu-is-open');
  };

  menuToggle.addEventListener('click', () => {
    const isOpen = menuToggle.getAttribute('aria-expanded') === 'true';
    menuToggle.setAttribute('aria-expanded', String(!isOpen));
    navigation.classList.toggle('is-open', !isOpen);
    document.body.classList.toggle('menu-is-open', !isOpen);
  });

  navigation.addEventListener('click', (event) => {
    if (event.target.closest('a')) closeMenu();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeMenu();
  });
}

const slider = document.querySelector('.reviews-slider');

if (slider) {
  new Swiper(slider, {
    modules: [Navigation, A11y],
    slidesPerView: 1,
    spaceBetween: 16,
    watchOverflow: true,
    navigation: {
      nextEl: '.reviews-next',
      prevEl: '.reviews-prev',
    },
    breakpoints: {
      768: { slidesPerView: 2, spaceBetween: 22 },
      1180: { slidesPerView: 3, spaceBetween: 24 },
    },
  });
}

const caseStudiesSlider = document.querySelector('.case-studies-slider');

if (caseStudiesSlider) {
  const caseStudiesCurrent = document.querySelector('[data-case-studies-current]');
  const updateCaseStudiesCurrent = (swiper) => {
    if (caseStudiesCurrent) caseStudiesCurrent.textContent = String(swiper.realIndex + 1);
  };

  new Swiper(caseStudiesSlider, {
    modules: [Navigation, A11y],
    slidesPerView: 1,
    spaceBetween: 18,
    watchOverflow: true,
    navigation: {
      nextEl: '.case-studies-next',
      prevEl: '.case-studies-prev',
    },
    on: {
      init: updateCaseStudiesCurrent,
      slideChange: updateCaseStudiesCurrent,
    },
  });
}

document.querySelectorAll('[data-service-tabs]').forEach((tabsRoot) => {
  const tabs = Array.from(tabsRoot.querySelectorAll('[data-service-tab]'));
  const panels = Array.from(tabsRoot.querySelectorAll('[data-service-panel]'));
  const tabList = tabsRoot.querySelector('[role="tablist"]');
  const previousCategory = tabsRoot.querySelector('[data-service-carousel-prev]');
  const nextCategory = tabsRoot.querySelector('[data-service-carousel-next]');
  const carouselStatus = tabsRoot.querySelector('[data-service-carousel-status]');
  const mobileQuery = window.matchMedia('(max-width: 767px)');
  let scrollTimer = null;

  const updateCarouselStatus = (activeTab) => {
    if (!carouselStatus || !activeTab) return;
    carouselStatus.textContent = `${tabs.indexOf(activeTab) + 1} / ${tabs.length}`;
  };

  const centerMobileTab = (tab) => {
    if (!mobileQuery.matches || !tab) return;
    tab.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
  };

  const activateTab = (nextTab, moveFocus = false, centerTab = false) => {
    const targetId = nextTab.getAttribute('aria-controls');
    const targetPanel = targetId ? tabsRoot.querySelector(`#${CSS.escape(targetId)}`) : null;
    if (!targetPanel) return;

    tabs.forEach((tab) => {
      const isActive = tab === nextTab;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', String(isActive));
      tab.setAttribute('tabindex', isActive ? '0' : '-1');
    });

    panels.forEach((panel) => {
      const isActive = panel === targetPanel;
      panel.hidden = !isActive;
      panel.classList.toggle('is-active', isActive);
    });

    targetPanel.classList.remove('is-active');
    void targetPanel.offsetWidth;
    targetPanel.classList.add('is-active');

    updateCarouselStatus(nextTab);
    if (centerTab) centerMobileTab(nextTab);
    if (moveFocus) nextTab.focus();
  };

  tabs.forEach((tab, index) => {
    tab.addEventListener('click', () => activateTab(tab, false, true));
    tab.addEventListener('keydown', (event) => {
      let nextIndex = null;
      if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex = (index + 1) % tabs.length;
      if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') nextIndex = (index - 1 + tabs.length) % tabs.length;
      if (event.key === 'Home') nextIndex = 0;
      if (event.key === 'End') nextIndex = tabs.length - 1;
      if (nextIndex === null) return;
      event.preventDefault();
      activateTab(tabs[nextIndex], true, true);
    });
  });

  const moveCarousel = (direction) => {
    const currentIndex = tabs.findIndex((tab) => tab.classList.contains('is-active'));
    const nextIndex = (currentIndex + direction + tabs.length) % tabs.length;
    activateTab(tabs[nextIndex], false, true);
  };

  previousCategory?.addEventListener('click', () => moveCarousel(-1));
  nextCategory?.addEventListener('click', () => moveCarousel(1));

  tabList?.addEventListener('scroll', () => {
    if (!mobileQuery.matches) return;
    window.clearTimeout(scrollTimer);
    scrollTimer = window.setTimeout(() => {
      const listCenter = tabList.getBoundingClientRect().left + (tabList.clientWidth / 2);
      const closestTab = tabs.reduce((closest, tab) => {
        const tabRect = tab.getBoundingClientRect();
        const tabCenter = tabRect.left + (tabRect.width / 2);
        const closestRect = closest.getBoundingClientRect();
        const closestCenter = closestRect.left + (closestRect.width / 2);
        return Math.abs(tabCenter - listCenter) < Math.abs(closestCenter - listCenter) ? tab : closest;
      }, tabs[0]);

      if (closestTab && !closestTab.classList.contains('is-active')) {
        activateTab(closestTab);
      }
    }, 90);
  }, { passive: true });

  updateCarouselStatus(tabs.find((tab) => tab.classList.contains('is-active')));
});

const bookingModal = document.querySelector('[data-booking-modal]');

if (bookingModal) {
  const bookingDialog = bookingModal.querySelector('[data-booking-dialog]');
  const bookingScrollArea = bookingModal.querySelector('[data-booking-scroll-area]');
  const bookingSelect = bookingModal.querySelector('select[name="service"]');
  const bookingSelection = bookingModal.querySelector('[data-booking-selection]');
  const bookingSelectionText = bookingModal.querySelector('[data-booking-selection-text]');
  const bookingDate = bookingModal.querySelector('input[name="preferred-date"]');
  const bookingScrollCue = bookingModal.querySelector('[data-booking-scroll-cue]');
  const focusableSelector = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
  let previousFocus = null;
  let closeTimer = null;

  if (bookingDate && !bookingDate.min) {
    const today = new Date();
    const localDate = new Date(today.getTime() - (today.getTimezoneOffset() * 60000));
    bookingDate.min = localDate.toISOString().slice(0, 10);
  }

  const updateSelection = () => {
    if (!bookingSelect || !bookingSelection || !bookingSelectionText) return;
    const option = bookingSelect.options[bookingSelect.selectedIndex];
    const value = option?.value?.trim() || '';
    bookingSelection.hidden = !value;
    bookingSelectionText.textContent = value;
  };

  const chooseService = (service) => {
    if (!bookingSelect || !service) return;
    const option = Array.from(bookingSelect.options).find((item) => (
      item.value.trim() === service.trim() || item.textContent.trim() === service.trim()
    ));

    if (option) {
      bookingSelect.value = option.value;
      bookingSelect.dispatchEvent(new Event('change', { bubbles: true }));
    }
  };

  const updateScrollCue = () => {
    if (!bookingDialog || !bookingScrollArea || !bookingScrollCue) return;
    const hasMoreContent = bookingScrollArea.scrollHeight > bookingScrollArea.clientHeight + 8;
    const isAtTop = bookingScrollArea.scrollTop < 12;
    const showCue = hasMoreContent && isAtTop;
    bookingScrollCue.hidden = !showCue;
    bookingDialog.classList.toggle('has-scroll-cue', showCue);
  };

  const openBooking = (trigger) => {
    window.clearTimeout(closeTimer);
    previousFocus = trigger;
    bookingModal.hidden = false;
    document.body.classList.add('booking-is-open');
    if (bookingScrollArea) bookingScrollArea.scrollTop = 0;
    chooseService(trigger.dataset.bookingService || '');
    updateSelection();

    window.requestAnimationFrame(() => {
      bookingModal.classList.add('is-open');
      updateScrollCue();
      const firstField = bookingDialog?.querySelector('input:not([type="hidden"]), select, textarea');
      (firstField || bookingDialog)?.focus();
    });
  };

  const closeBooking = () => {
    bookingModal.classList.remove('is-open');
    document.body.classList.remove('booking-is-open');
    closeTimer = window.setTimeout(() => {
      bookingModal.hidden = true;
      if (previousFocus instanceof HTMLElement) previousFocus.focus();
    }, 180);
  };

  document.querySelectorAll('[data-booking-open]').forEach((trigger) => {
    trigger.addEventListener('click', () => openBooking(trigger));
  });

  bookingModal.querySelectorAll('[data-booking-close]').forEach((control) => {
    control.addEventListener('click', closeBooking);
  });

  bookingSelect?.addEventListener('change', updateSelection);
  bookingScrollArea?.addEventListener('scroll', updateScrollCue, { passive: true });
  window.addEventListener('resize', updateScrollCue);

  bookingModal.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      event.preventDefault();
      closeBooking();
      return;
    }

    if (event.key !== 'Tab' || !bookingDialog) return;
    const focusable = Array.from(bookingDialog.querySelectorAll(focusableSelector)).filter((element) => element.offsetParent !== null);
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });
}

document.querySelectorAll('a[href^="#"]').forEach((link) => {
  link.addEventListener('click', (event) => {
    const selector = link.getAttribute('href');
    if (!selector || selector === '#') return;
    const target = document.querySelector(selector);
    if (!target) return;
    event.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
});
